module.exports = __webpack_public_path__ + "img/login-banner.c380ff15.jpg";